import { useTranslation } from 'react-i18next'

import { Button, LayoutLogo, SadSmileyImg, SmallText, Title } from '@leanpay/ui'

import LpLogoImg from 'assets/images/lp_logo.png'

interface TechnicalErrorFallbackProps {
    onRetry: () => void
}

export const TechnicalErrorFallback = ({ onRetry }: TechnicalErrorFallbackProps) => {
    const { t } = useTranslation()

    return (
        <LayoutLogo className="max-w-full" logo={LpLogoImg}>
            <Title testId="error-boundary-title" className="mb-3">
                {t('errorBoundary.title')}
            </Title>
            <div className="flex flex-col items-center p-4 mb-20 rounded-md bg-white w-full">
                <img src={SadSmileyImg} alt="" />
                <SmallText
                    testId="error-boundary-message"
                    className="text-center mt-4"
                    role="alert"
                >
                    {t('errorBoundary.message')}
                </SmallText>
            </div>

            <Button onClick={onRetry} testId="error-boundary-retry">
                {t('errorBoundary.tryAgain')}
            </Button>
        </LayoutLogo>
    )
}
